import { getlocalStorageLogin } from "common/components/apiConfig";
import { useEffect, useState } from "react";
import { BsFillBellFill } from "react-icons/bs"; // آیکون برای نمایش
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { actionTypes } from "redux/ipo/select_active_ipos";

const AlertSupply = () => {
  const [initialOffers, setInitialOffers] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const reducer = useSelector((state) => state.selectActiveIposReducer);

  useEffect(() => {
    dispatch({ type: actionTypes.selectActiveIposAsync, payload: "" });
  }, [dispatch]);

  useEffect(() => {
    if (reducer?.data?.data?.results) {
      setInitialOffers(reducer?.data?.data?.results);
    }
  }, [reducer?.data?.data?.results]);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsActive((prevState) => !prevState);
    }, 700);

    return () => clearInterval(interval);
  }, []);

  const handleGoToInitialSupply = () => {
    history.push("/ipo");
  };

  return (
    <>
      {initialOffers?.length > 0 && (
        <div
          className="flex items-center cursor-pointer"
          onClick={handleGoToInitialSupply}
        >
          <div
            className={`px-2 py-1 text-xs rounded-lg flex items-center ${"bg-green-500 text-white"}`}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              flexWrap: "wrap",
              width: "100%",
              justifyContent: "center",
              marginInlineStart: 6,
            }}
          >
            <BsFillBellFill
              size={18}
              className={`mr-2 ${isActive ? "text-yellow-400" : "text-white"}`}
            />
            <span style={{ minWidth: "60px" }} className="w-full">
              عرضه اولیه
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export { AlertSupply };
